export default "__VITE_ASSET__CfRej4fT__"